import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {updateEmployee, fetchEmployeeById} from "../../store/employee-slice";
import {employeeSchema} from "../../schema/employeeSchema";
import {getFormData} from "../../models/employeeModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {appendNested, getValidatedLimit} from "../../components/Utility";

const EmployeeEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.employee);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.employee);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchEmployeeById(params.employeeId));
    }, [dispatch, params.employeeId]);

    const employee = items.find(item => item.id === params.employeeId);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        const formData = new FormData();

        appendNested(formData, {
            id: userRole.scopeId,
            ...data,
        });

        /* for (const [key, value] of formData.entries()) {
           console.log(key, value);
       }*/

        dispatch(updateEmployee({
            id: params.employeeId,
            data: formData
        }));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }
    const schema = employeeSchema();
    delete schema.password
    const initialData = getFormData(employee);

    return (
        <>
            <SubHeader title="Update Employee">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmployeeEdit;
